
import { convertStyleData } from '@utils/tools';

import './BreaklineCustomComponent.less';

export default function BreaklineCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component breakline" style={styleObj}></div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/breakline-custom-component/BreaklineCustomComponent.jsx